module.exports = __webpack_public_path__ + "static/media/message-square.877713f9.svg";